import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppAnimations } from '../../animations';
import { SnackBarService } from '../../services/app-services/snack-bar.service';
import { LoadingService } from '../../services/loading.service';
import { UsersService } from '../../services/users.service';
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from 'ngx-clipboard';
import { MaterialModule } from '../../shared/material.module';

@Component({
  selector: 'app-email-token',
  templateUrl: './email-token.component.html',
  styleUrls: ['./email-token.component.scss'],
  animations: AppAnimations,
  standalone:true,
  imports:[
    A11yModule,
    CdkTableModule,
    ClipboardModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MaterialModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    OverlayModule,
    PortalModule,
    ReactiveFormsModule,
    ScrollingModule,
  ]
})
export class EmailTokenComponent implements OnInit {
  public enterToken!: FormGroup;
  public enterTokenError: string | any;
  public data: object | unknown;
  public resetData: any;
  public email;

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly modalData: any,
    private readonly matDialogRef: MatDialogRef<EmailTokenComponent>,
    private readonly formBuilder: FormBuilder,
    private readonly usersService: UsersService,
    private readonly loader: LoadingService,
    private readonly snackBar: SnackBarService,
    private readonly snackService: SnackBarService
  ) {
    this.email = modalData.profileData;
    
  }

  ngOnInit(): void {
    this.enterTokenError = { token: {} };
    this.enterToken = this.formBuilder.group({
      token: ['', [Validators.required]],
    });

    // this.enterEmailId.valueChanges.subscribe(() => {
    //   this.onLoginFormValuesChanged();
    // });
  }
  public verify() {
    this.resetData = this.enterToken.value;
   
    this.resetData.email = this.email;
    
    // this.loader.show();
    
    this.usersService.setEmail(this.resetData).subscribe(
      () => {
        this.snackBar.success('Email Updated Successfully');
        // this.router.navigate(['auth/login']);
        this.matDialogRef.close(true);
      },
      (error) => {
        this.snackService.error(error.error.message);
      }
    );
    // ConsoleLogger.log(this.setUpAccountForm.value());
  }
}
